// extracted by mini-css-extract-plugin
module.exports = {"headline":"az_Mdb","image":"az_Ndb","description":"az_Odb"};